export default [
  {
    path: '/farm-manager',
    component: () => import('@/layouts/GeneralLayout.vue'),
    children: [
      {
        path: 'farms',
        name: 'farms',
        component: () => import('@/views/farm-manager/farms/Index.vue'),
        meta: {
          redirectIfGuest: true,
          resource: 'farm-manager',
          action: 'access-farms',
        },
      },
      {
        path: 'farms/:id',
        name: 'farm-detail',
        component: () => import('@/views/farm-manager/farms/Detail.vue'),
        meta: {
          redirectIfGuest: true,
          resource: 'farm-manager',
          action: 'access-farms',
        },
      },
      {
        path: 'production',
        name: 'production',
        component: () => import('@/views/farm-manager/production/Index.vue'),
        meta: {
          redirectIfGuest: true,
          resource: 'farm-manager',
          action: 'access-production',
        },
      },
      {
        path: 'production/:memberId',
        name: 'production-farmer-farms',
        component: () => import('@/views/farm-manager/production/FarmerFarms.vue'),
        meta: {
          redirectIfGuest: true,
          resource: 'farm-manager',
          action: 'access-production',
        },
      },
    ],
  },
]
